export enum StatusServiceEnum {
    ABERTO = "aberto",
    PENDENTE = "pendente",
    RESOLVIDO = "resolvido",
}